/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthenticatedOpsRouteImport } from './routes/_authenticated/ops'
import { Route as AuthenticatedContactsRouteImport } from './routes/_authenticated/contacts'
import { Route as AuthenticatedEventsIndexRouteImport } from './routes/_authenticated/events/index'
import { Route as AccountActivationEmailRouteImport } from './routes/account/activation/$email'
import { Route as AuthenticatedOpsTerminalsRouteImport } from './routes/_authenticated/ops/terminals'
import { Route as AuthenticatedOpsSystemRouteImport } from './routes/_authenticated/ops/system'
import { Route as AuthenticatedOpsRevenueRouteImport } from './routes/_authenticated/ops/revenue'
import { Route as AuthenticatedOpsPulseRouteImport } from './routes/_authenticated/ops/pulse'
import { Route as AuthenticatedOpsFraudRouteImport } from './routes/_authenticated/ops/fraud'
import { Route as AuthenticatedEventsEventIdRouteImport } from './routes/_authenticated/events/$eventId'
import { Route as AuthenticatedContactsUserIdRouteImport } from './routes/_authenticated/contacts_.$userId'
import { Route as AuthenticatedAdminSupportChatAnalyticsRouteImport } from './routes/_authenticated/admin/support-chat-analytics'
import { Route as AccountActivationEmailCodeRouteImport } from './routes/account/activation/$email/$code'
import { Route as AuthenticatedOpsEventsNewRouteImport } from './routes/_authenticated/ops/events.new'
import { Route as AuthenticatedEventsEventIdVouchersRouteImport } from './routes/_authenticated/events/$eventId/vouchers'
import { Route as AuthenticatedEventsEventIdVendorsRouteImport } from './routes/_authenticated/events/$eventId/vendors'
import { Route as AuthenticatedEventsEventIdUsersRouteImport } from './routes/_authenticated/events/$eventId/users'
import { Route as AuthenticatedEventsEventIdTransferRouteImport } from './routes/_authenticated/events/$eventId/transfer'
import { Route as AuthenticatedEventsEventIdTransactionsRouteImport } from './routes/_authenticated/events/$eventId/transactions'
import { Route as AuthenticatedEventsEventIdToolkitRouteImport } from './routes/_authenticated/events/$eventId/toolkit'
import { Route as AuthenticatedEventsEventIdSupportRouteImport } from './routes/_authenticated/events/$eventId/support'
import { Route as AuthenticatedEventsEventIdSiteMapRouteImport } from './routes/_authenticated/events/$eventId/site-map'
import { Route as AuthenticatedEventsEventIdSettingsRouteImport } from './routes/_authenticated/events/$eventId/settings'
import { Route as AuthenticatedEventsEventIdReportingRouteImport } from './routes/_authenticated/events/$eventId/reporting'
import { Route as AuthenticatedEventsEventIdReloadRouteImport } from './routes/_authenticated/events/$eventId/reload'
import { Route as AuthenticatedEventsEventIdPromotionsRouteImport } from './routes/_authenticated/events/$eventId/promotions'
import { Route as AuthenticatedEventsEventIdOrdersRouteImport } from './routes/_authenticated/events/$eventId/orders'
import { Route as AuthenticatedEventsEventIdMenuRouteImport } from './routes/_authenticated/events/$eventId/menu'
import { Route as AuthenticatedEventsEventIdLiveStatsRouteImport } from './routes/_authenticated/events/$eventId/live-stats'
import { Route as AuthenticatedEventsEventIdIntegrationsRouteImport } from './routes/_authenticated/events/$eventId/integrations'
import { Route as AuthenticatedEventsEventIdHomeLayoutRouteImport } from './routes/_authenticated/events/$eventId/home-layout'
import { Route as AuthenticatedEventsEventIdFraudRouteImport } from './routes/_authenticated/events/$eventId/fraud'
import { Route as AuthenticatedEventsEventIdFinancialsRouteImport } from './routes/_authenticated/events/$eventId/financials'
import { Route as AuthenticatedEventsEventIdDashboardRouteImport } from './routes/_authenticated/events/$eventId/dashboard'
import { Route as AuthenticatedEventsEventIdCardPhonesRouteImport } from './routes/_authenticated/events/$eventId/card-phones'
import { Route as AuthenticatedEventsEventIdCardPaymentsRouteImport } from './routes/_authenticated/events/$eventId/card-payments'
import { Route as AuthenticatedEventsEventIdEventContentIndexRouteImport } from './routes/_authenticated/events/$eventId/event-content/index'
import { Route as AuthenticatedEventsEventIdVendorsVendorIdRouteImport } from './routes/_authenticated/events/$eventId/vendors.$vendorId'
import { Route as AuthenticatedEventsEventIdFinancialsSupportReloadsRouteImport } from './routes/_authenticated/events/$eventId/financials_.support-reloads'
import { Route as AuthenticatedEventsEventIdEventContentCreateRouteImport } from './routes/_authenticated/events/$eventId/event-content/create'
import { Route as AuthenticatedEventsEventIdFraudUsersUserIdRouteImport } from './routes/_authenticated/events/$eventId/fraud_.users.$userId'
import { Route as AuthenticatedEventsEventIdEventContentPageIdEditRouteImport } from './routes/_authenticated/events/$eventId/event-content/$pageId/edit'
import { Route as AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRouteImport } from './routes/_authenticated/events/$eventId/vendors.$vendorId.locations.$locationId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOpsRoute = AuthenticatedOpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedContactsRoute = AuthenticatedContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEventsIndexRoute =
  AuthenticatedEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AccountActivationEmailRoute = AccountActivationEmailRouteImport.update({
  id: '/account/activation/$email',
  path: '/account/activation/$email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOpsTerminalsRoute =
  AuthenticatedOpsTerminalsRouteImport.update({
    id: '/terminals',
    path: '/terminals',
    getParentRoute: () => AuthenticatedOpsRoute,
  } as any)
const AuthenticatedOpsSystemRoute = AuthenticatedOpsSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AuthenticatedOpsRoute,
} as any)
const AuthenticatedOpsRevenueRoute = AuthenticatedOpsRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AuthenticatedOpsRoute,
} as any)
const AuthenticatedOpsPulseRoute = AuthenticatedOpsPulseRouteImport.update({
  id: '/pulse',
  path: '/pulse',
  getParentRoute: () => AuthenticatedOpsRoute,
} as any)
const AuthenticatedOpsFraudRoute = AuthenticatedOpsFraudRouteImport.update({
  id: '/fraud',
  path: '/fraud',
  getParentRoute: () => AuthenticatedOpsRoute,
} as any)
const AuthenticatedEventsEventIdRoute =
  AuthenticatedEventsEventIdRouteImport.update({
    id: '/events/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContactsUserIdRoute =
  AuthenticatedContactsUserIdRouteImport.update({
    id: '/contacts_/$userId',
    path: '/contacts/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminSupportChatAnalyticsRoute =
  AuthenticatedAdminSupportChatAnalyticsRouteImport.update({
    id: '/admin/support-chat-analytics',
    path: '/admin/support-chat-analytics',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AccountActivationEmailCodeRoute =
  AccountActivationEmailCodeRouteImport.update({
    id: '/$code',
    path: '/$code',
    getParentRoute: () => AccountActivationEmailRoute,
  } as any)
const AuthenticatedOpsEventsNewRoute =
  AuthenticatedOpsEventsNewRouteImport.update({
    id: '/events/new',
    path: '/events/new',
    getParentRoute: () => AuthenticatedOpsRoute,
  } as any)
const AuthenticatedEventsEventIdVouchersRoute =
  AuthenticatedEventsEventIdVouchersRouteImport.update({
    id: '/vouchers',
    path: '/vouchers',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdVendorsRoute =
  AuthenticatedEventsEventIdVendorsRouteImport.update({
    id: '/vendors',
    path: '/vendors',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdUsersRoute =
  AuthenticatedEventsEventIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdTransferRoute =
  AuthenticatedEventsEventIdTransferRouteImport.update({
    id: '/transfer',
    path: '/transfer',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdTransactionsRoute =
  AuthenticatedEventsEventIdTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdToolkitRoute =
  AuthenticatedEventsEventIdToolkitRouteImport.update({
    id: '/toolkit',
    path: '/toolkit',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdSupportRoute =
  AuthenticatedEventsEventIdSupportRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdSiteMapRoute =
  AuthenticatedEventsEventIdSiteMapRouteImport.update({
    id: '/site-map',
    path: '/site-map',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdSettingsRoute =
  AuthenticatedEventsEventIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdReportingRoute =
  AuthenticatedEventsEventIdReportingRouteImport.update({
    id: '/reporting',
    path: '/reporting',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdReloadRoute =
  AuthenticatedEventsEventIdReloadRouteImport.update({
    id: '/reload',
    path: '/reload',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdPromotionsRoute =
  AuthenticatedEventsEventIdPromotionsRouteImport.update({
    id: '/promotions',
    path: '/promotions',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdOrdersRoute =
  AuthenticatedEventsEventIdOrdersRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdMenuRoute =
  AuthenticatedEventsEventIdMenuRouteImport.update({
    id: '/menu',
    path: '/menu',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdLiveStatsRoute =
  AuthenticatedEventsEventIdLiveStatsRouteImport.update({
    id: '/live-stats',
    path: '/live-stats',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdIntegrationsRoute =
  AuthenticatedEventsEventIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdHomeLayoutRoute =
  AuthenticatedEventsEventIdHomeLayoutRouteImport.update({
    id: '/home-layout',
    path: '/home-layout',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdFraudRoute =
  AuthenticatedEventsEventIdFraudRouteImport.update({
    id: '/fraud',
    path: '/fraud',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdFinancialsRoute =
  AuthenticatedEventsEventIdFinancialsRouteImport.update({
    id: '/financials',
    path: '/financials',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdDashboardRoute =
  AuthenticatedEventsEventIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdCardPhonesRoute =
  AuthenticatedEventsEventIdCardPhonesRouteImport.update({
    id: '/card-phones',
    path: '/card-phones',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdCardPaymentsRoute =
  AuthenticatedEventsEventIdCardPaymentsRouteImport.update({
    id: '/card-payments',
    path: '/card-payments',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdEventContentIndexRoute =
  AuthenticatedEventsEventIdEventContentIndexRouteImport.update({
    id: '/event-content/',
    path: '/event-content/',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdVendorsVendorIdRoute =
  AuthenticatedEventsEventIdVendorsVendorIdRouteImport.update({
    id: '/$vendorId',
    path: '/$vendorId',
    getParentRoute: () => AuthenticatedEventsEventIdVendorsRoute,
  } as any)
const AuthenticatedEventsEventIdFinancialsSupportReloadsRoute =
  AuthenticatedEventsEventIdFinancialsSupportReloadsRouteImport.update({
    id: '/financials_/support-reloads',
    path: '/financials/support-reloads',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdEventContentCreateRoute =
  AuthenticatedEventsEventIdEventContentCreateRouteImport.update({
    id: '/event-content/create',
    path: '/event-content/create',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdFraudUsersUserIdRoute =
  AuthenticatedEventsEventIdFraudUsersUserIdRouteImport.update({
    id: '/fraud_/users/$userId',
    path: '/fraud/users/$userId',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdEventContentPageIdEditRoute =
  AuthenticatedEventsEventIdEventContentPageIdEditRouteImport.update({
    id: '/event-content/$pageId/edit',
    path: '/event-content/$pageId/edit',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRoute =
  AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRouteImport.update(
    {
      id: '/locations/$locationId',
      path: '/locations/$locationId',
      getParentRoute: () => AuthenticatedEventsEventIdVendorsVendorIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contacts': typeof AuthenticatedContactsRoute
  '/ops': typeof AuthenticatedOpsRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/admin/support-chat-analytics': typeof AuthenticatedAdminSupportChatAnalyticsRoute
  '/contacts/$userId': typeof AuthenticatedContactsUserIdRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdRouteWithChildren
  '/ops/fraud': typeof AuthenticatedOpsFraudRoute
  '/ops/pulse': typeof AuthenticatedOpsPulseRoute
  '/ops/revenue': typeof AuthenticatedOpsRevenueRoute
  '/ops/system': typeof AuthenticatedOpsSystemRoute
  '/ops/terminals': typeof AuthenticatedOpsTerminalsRoute
  '/account/activation/$email': typeof AccountActivationEmailRouteWithChildren
  '/events/': typeof AuthenticatedEventsIndexRoute
  '/events/$eventId/card-payments': typeof AuthenticatedEventsEventIdCardPaymentsRoute
  '/events/$eventId/card-phones': typeof AuthenticatedEventsEventIdCardPhonesRoute
  '/events/$eventId/dashboard': typeof AuthenticatedEventsEventIdDashboardRoute
  '/events/$eventId/financials': typeof AuthenticatedEventsEventIdFinancialsRoute
  '/events/$eventId/fraud': typeof AuthenticatedEventsEventIdFraudRoute
  '/events/$eventId/home-layout': typeof AuthenticatedEventsEventIdHomeLayoutRoute
  '/events/$eventId/integrations': typeof AuthenticatedEventsEventIdIntegrationsRoute
  '/events/$eventId/live-stats': typeof AuthenticatedEventsEventIdLiveStatsRoute
  '/events/$eventId/menu': typeof AuthenticatedEventsEventIdMenuRoute
  '/events/$eventId/orders': typeof AuthenticatedEventsEventIdOrdersRoute
  '/events/$eventId/promotions': typeof AuthenticatedEventsEventIdPromotionsRoute
  '/events/$eventId/reload': typeof AuthenticatedEventsEventIdReloadRoute
  '/events/$eventId/reporting': typeof AuthenticatedEventsEventIdReportingRoute
  '/events/$eventId/settings': typeof AuthenticatedEventsEventIdSettingsRoute
  '/events/$eventId/site-map': typeof AuthenticatedEventsEventIdSiteMapRoute
  '/events/$eventId/support': typeof AuthenticatedEventsEventIdSupportRoute
  '/events/$eventId/toolkit': typeof AuthenticatedEventsEventIdToolkitRoute
  '/events/$eventId/transactions': typeof AuthenticatedEventsEventIdTransactionsRoute
  '/events/$eventId/transfer': typeof AuthenticatedEventsEventIdTransferRoute
  '/events/$eventId/users': typeof AuthenticatedEventsEventIdUsersRoute
  '/events/$eventId/vendors': typeof AuthenticatedEventsEventIdVendorsRouteWithChildren
  '/events/$eventId/vouchers': typeof AuthenticatedEventsEventIdVouchersRoute
  '/ops/events/new': typeof AuthenticatedOpsEventsNewRoute
  '/account/activation/$email/$code': typeof AccountActivationEmailCodeRoute
  '/events/$eventId/event-content/create': typeof AuthenticatedEventsEventIdEventContentCreateRoute
  '/events/$eventId/financials/support-reloads': typeof AuthenticatedEventsEventIdFinancialsSupportReloadsRoute
  '/events/$eventId/vendors/$vendorId': typeof AuthenticatedEventsEventIdVendorsVendorIdRouteWithChildren
  '/events/$eventId/event-content/': typeof AuthenticatedEventsEventIdEventContentIndexRoute
  '/events/$eventId/event-content/$pageId/edit': typeof AuthenticatedEventsEventIdEventContentPageIdEditRoute
  '/events/$eventId/fraud/users/$userId': typeof AuthenticatedEventsEventIdFraudUsersUserIdRoute
  '/events/$eventId/vendors/$vendorId/locations/$locationId': typeof AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contacts': typeof AuthenticatedContactsRoute
  '/ops': typeof AuthenticatedOpsRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/admin/support-chat-analytics': typeof AuthenticatedAdminSupportChatAnalyticsRoute
  '/contacts/$userId': typeof AuthenticatedContactsUserIdRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdRouteWithChildren
  '/ops/fraud': typeof AuthenticatedOpsFraudRoute
  '/ops/pulse': typeof AuthenticatedOpsPulseRoute
  '/ops/revenue': typeof AuthenticatedOpsRevenueRoute
  '/ops/system': typeof AuthenticatedOpsSystemRoute
  '/ops/terminals': typeof AuthenticatedOpsTerminalsRoute
  '/account/activation/$email': typeof AccountActivationEmailRouteWithChildren
  '/events': typeof AuthenticatedEventsIndexRoute
  '/events/$eventId/card-payments': typeof AuthenticatedEventsEventIdCardPaymentsRoute
  '/events/$eventId/card-phones': typeof AuthenticatedEventsEventIdCardPhonesRoute
  '/events/$eventId/dashboard': typeof AuthenticatedEventsEventIdDashboardRoute
  '/events/$eventId/financials': typeof AuthenticatedEventsEventIdFinancialsRoute
  '/events/$eventId/fraud': typeof AuthenticatedEventsEventIdFraudRoute
  '/events/$eventId/home-layout': typeof AuthenticatedEventsEventIdHomeLayoutRoute
  '/events/$eventId/integrations': typeof AuthenticatedEventsEventIdIntegrationsRoute
  '/events/$eventId/live-stats': typeof AuthenticatedEventsEventIdLiveStatsRoute
  '/events/$eventId/menu': typeof AuthenticatedEventsEventIdMenuRoute
  '/events/$eventId/orders': typeof AuthenticatedEventsEventIdOrdersRoute
  '/events/$eventId/promotions': typeof AuthenticatedEventsEventIdPromotionsRoute
  '/events/$eventId/reload': typeof AuthenticatedEventsEventIdReloadRoute
  '/events/$eventId/reporting': typeof AuthenticatedEventsEventIdReportingRoute
  '/events/$eventId/settings': typeof AuthenticatedEventsEventIdSettingsRoute
  '/events/$eventId/site-map': typeof AuthenticatedEventsEventIdSiteMapRoute
  '/events/$eventId/support': typeof AuthenticatedEventsEventIdSupportRoute
  '/events/$eventId/toolkit': typeof AuthenticatedEventsEventIdToolkitRoute
  '/events/$eventId/transactions': typeof AuthenticatedEventsEventIdTransactionsRoute
  '/events/$eventId/transfer': typeof AuthenticatedEventsEventIdTransferRoute
  '/events/$eventId/users': typeof AuthenticatedEventsEventIdUsersRoute
  '/events/$eventId/vendors': typeof AuthenticatedEventsEventIdVendorsRouteWithChildren
  '/events/$eventId/vouchers': typeof AuthenticatedEventsEventIdVouchersRoute
  '/ops/events/new': typeof AuthenticatedOpsEventsNewRoute
  '/account/activation/$email/$code': typeof AccountActivationEmailCodeRoute
  '/events/$eventId/event-content/create': typeof AuthenticatedEventsEventIdEventContentCreateRoute
  '/events/$eventId/financials/support-reloads': typeof AuthenticatedEventsEventIdFinancialsSupportReloadsRoute
  '/events/$eventId/vendors/$vendorId': typeof AuthenticatedEventsEventIdVendorsVendorIdRouteWithChildren
  '/events/$eventId/event-content': typeof AuthenticatedEventsEventIdEventContentIndexRoute
  '/events/$eventId/event-content/$pageId/edit': typeof AuthenticatedEventsEventIdEventContentPageIdEditRoute
  '/events/$eventId/fraud/users/$userId': typeof AuthenticatedEventsEventIdFraudUsersUserIdRoute
  '/events/$eventId/vendors/$vendorId/locations/$locationId': typeof AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/contacts': typeof AuthenticatedContactsRoute
  '/_authenticated/ops': typeof AuthenticatedOpsRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/_authenticated/admin/support-chat-analytics': typeof AuthenticatedAdminSupportChatAnalyticsRoute
  '/_authenticated/contacts_/$userId': typeof AuthenticatedContactsUserIdRoute
  '/_authenticated/events/$eventId': typeof AuthenticatedEventsEventIdRouteWithChildren
  '/_authenticated/ops/fraud': typeof AuthenticatedOpsFraudRoute
  '/_authenticated/ops/pulse': typeof AuthenticatedOpsPulseRoute
  '/_authenticated/ops/revenue': typeof AuthenticatedOpsRevenueRoute
  '/_authenticated/ops/system': typeof AuthenticatedOpsSystemRoute
  '/_authenticated/ops/terminals': typeof AuthenticatedOpsTerminalsRoute
  '/account/activation/$email': typeof AccountActivationEmailRouteWithChildren
  '/_authenticated/events/': typeof AuthenticatedEventsIndexRoute
  '/_authenticated/events/$eventId/card-payments': typeof AuthenticatedEventsEventIdCardPaymentsRoute
  '/_authenticated/events/$eventId/card-phones': typeof AuthenticatedEventsEventIdCardPhonesRoute
  '/_authenticated/events/$eventId/dashboard': typeof AuthenticatedEventsEventIdDashboardRoute
  '/_authenticated/events/$eventId/financials': typeof AuthenticatedEventsEventIdFinancialsRoute
  '/_authenticated/events/$eventId/fraud': typeof AuthenticatedEventsEventIdFraudRoute
  '/_authenticated/events/$eventId/home-layout': typeof AuthenticatedEventsEventIdHomeLayoutRoute
  '/_authenticated/events/$eventId/integrations': typeof AuthenticatedEventsEventIdIntegrationsRoute
  '/_authenticated/events/$eventId/live-stats': typeof AuthenticatedEventsEventIdLiveStatsRoute
  '/_authenticated/events/$eventId/menu': typeof AuthenticatedEventsEventIdMenuRoute
  '/_authenticated/events/$eventId/orders': typeof AuthenticatedEventsEventIdOrdersRoute
  '/_authenticated/events/$eventId/promotions': typeof AuthenticatedEventsEventIdPromotionsRoute
  '/_authenticated/events/$eventId/reload': typeof AuthenticatedEventsEventIdReloadRoute
  '/_authenticated/events/$eventId/reporting': typeof AuthenticatedEventsEventIdReportingRoute
  '/_authenticated/events/$eventId/settings': typeof AuthenticatedEventsEventIdSettingsRoute
  '/_authenticated/events/$eventId/site-map': typeof AuthenticatedEventsEventIdSiteMapRoute
  '/_authenticated/events/$eventId/support': typeof AuthenticatedEventsEventIdSupportRoute
  '/_authenticated/events/$eventId/toolkit': typeof AuthenticatedEventsEventIdToolkitRoute
  '/_authenticated/events/$eventId/transactions': typeof AuthenticatedEventsEventIdTransactionsRoute
  '/_authenticated/events/$eventId/transfer': typeof AuthenticatedEventsEventIdTransferRoute
  '/_authenticated/events/$eventId/users': typeof AuthenticatedEventsEventIdUsersRoute
  '/_authenticated/events/$eventId/vendors': typeof AuthenticatedEventsEventIdVendorsRouteWithChildren
  '/_authenticated/events/$eventId/vouchers': typeof AuthenticatedEventsEventIdVouchersRoute
  '/_authenticated/ops/events/new': typeof AuthenticatedOpsEventsNewRoute
  '/account/activation/$email/$code': typeof AccountActivationEmailCodeRoute
  '/_authenticated/events/$eventId/event-content/create': typeof AuthenticatedEventsEventIdEventContentCreateRoute
  '/_authenticated/events/$eventId/financials_/support-reloads': typeof AuthenticatedEventsEventIdFinancialsSupportReloadsRoute
  '/_authenticated/events/$eventId/vendors/$vendorId': typeof AuthenticatedEventsEventIdVendorsVendorIdRouteWithChildren
  '/_authenticated/events/$eventId/event-content/': typeof AuthenticatedEventsEventIdEventContentIndexRoute
  '/_authenticated/events/$eventId/event-content/$pageId/edit': typeof AuthenticatedEventsEventIdEventContentPageIdEditRoute
  '/_authenticated/events/$eventId/fraud_/users/$userId': typeof AuthenticatedEventsEventIdFraudUsersUserIdRoute
  '/_authenticated/events/$eventId/vendors/$vendorId/locations/$locationId': typeof AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contacts'
    | '/ops'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/admin/support-chat-analytics'
    | '/contacts/$userId'
    | '/events/$eventId'
    | '/ops/fraud'
    | '/ops/pulse'
    | '/ops/revenue'
    | '/ops/system'
    | '/ops/terminals'
    | '/account/activation/$email'
    | '/events/'
    | '/events/$eventId/card-payments'
    | '/events/$eventId/card-phones'
    | '/events/$eventId/dashboard'
    | '/events/$eventId/financials'
    | '/events/$eventId/fraud'
    | '/events/$eventId/home-layout'
    | '/events/$eventId/integrations'
    | '/events/$eventId/live-stats'
    | '/events/$eventId/menu'
    | '/events/$eventId/orders'
    | '/events/$eventId/promotions'
    | '/events/$eventId/reload'
    | '/events/$eventId/reporting'
    | '/events/$eventId/settings'
    | '/events/$eventId/site-map'
    | '/events/$eventId/support'
    | '/events/$eventId/toolkit'
    | '/events/$eventId/transactions'
    | '/events/$eventId/transfer'
    | '/events/$eventId/users'
    | '/events/$eventId/vendors'
    | '/events/$eventId/vouchers'
    | '/ops/events/new'
    | '/account/activation/$email/$code'
    | '/events/$eventId/event-content/create'
    | '/events/$eventId/financials/support-reloads'
    | '/events/$eventId/vendors/$vendorId'
    | '/events/$eventId/event-content/'
    | '/events/$eventId/event-content/$pageId/edit'
    | '/events/$eventId/fraud/users/$userId'
    | '/events/$eventId/vendors/$vendorId/locations/$locationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contacts'
    | '/ops'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/admin/support-chat-analytics'
    | '/contacts/$userId'
    | '/events/$eventId'
    | '/ops/fraud'
    | '/ops/pulse'
    | '/ops/revenue'
    | '/ops/system'
    | '/ops/terminals'
    | '/account/activation/$email'
    | '/events'
    | '/events/$eventId/card-payments'
    | '/events/$eventId/card-phones'
    | '/events/$eventId/dashboard'
    | '/events/$eventId/financials'
    | '/events/$eventId/fraud'
    | '/events/$eventId/home-layout'
    | '/events/$eventId/integrations'
    | '/events/$eventId/live-stats'
    | '/events/$eventId/menu'
    | '/events/$eventId/orders'
    | '/events/$eventId/promotions'
    | '/events/$eventId/reload'
    | '/events/$eventId/reporting'
    | '/events/$eventId/settings'
    | '/events/$eventId/site-map'
    | '/events/$eventId/support'
    | '/events/$eventId/toolkit'
    | '/events/$eventId/transactions'
    | '/events/$eventId/transfer'
    | '/events/$eventId/users'
    | '/events/$eventId/vendors'
    | '/events/$eventId/vouchers'
    | '/ops/events/new'
    | '/account/activation/$email/$code'
    | '/events/$eventId/event-content/create'
    | '/events/$eventId/financials/support-reloads'
    | '/events/$eventId/vendors/$vendorId'
    | '/events/$eventId/event-content'
    | '/events/$eventId/event-content/$pageId/edit'
    | '/events/$eventId/fraud/users/$userId'
    | '/events/$eventId/vendors/$vendorId/locations/$locationId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/contacts'
    | '/_authenticated/ops'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/_authenticated/admin/support-chat-analytics'
    | '/_authenticated/contacts_/$userId'
    | '/_authenticated/events/$eventId'
    | '/_authenticated/ops/fraud'
    | '/_authenticated/ops/pulse'
    | '/_authenticated/ops/revenue'
    | '/_authenticated/ops/system'
    | '/_authenticated/ops/terminals'
    | '/account/activation/$email'
    | '/_authenticated/events/'
    | '/_authenticated/events/$eventId/card-payments'
    | '/_authenticated/events/$eventId/card-phones'
    | '/_authenticated/events/$eventId/dashboard'
    | '/_authenticated/events/$eventId/financials'
    | '/_authenticated/events/$eventId/fraud'
    | '/_authenticated/events/$eventId/home-layout'
    | '/_authenticated/events/$eventId/integrations'
    | '/_authenticated/events/$eventId/live-stats'
    | '/_authenticated/events/$eventId/menu'
    | '/_authenticated/events/$eventId/orders'
    | '/_authenticated/events/$eventId/promotions'
    | '/_authenticated/events/$eventId/reload'
    | '/_authenticated/events/$eventId/reporting'
    | '/_authenticated/events/$eventId/settings'
    | '/_authenticated/events/$eventId/site-map'
    | '/_authenticated/events/$eventId/support'
    | '/_authenticated/events/$eventId/toolkit'
    | '/_authenticated/events/$eventId/transactions'
    | '/_authenticated/events/$eventId/transfer'
    | '/_authenticated/events/$eventId/users'
    | '/_authenticated/events/$eventId/vendors'
    | '/_authenticated/events/$eventId/vouchers'
    | '/_authenticated/ops/events/new'
    | '/account/activation/$email/$code'
    | '/_authenticated/events/$eventId/event-content/create'
    | '/_authenticated/events/$eventId/financials_/support-reloads'
    | '/_authenticated/events/$eventId/vendors/$vendorId'
    | '/_authenticated/events/$eventId/event-content/'
    | '/_authenticated/events/$eventId/event-content/$pageId/edit'
    | '/_authenticated/events/$eventId/fraud_/users/$userId'
    | '/_authenticated/events/$eventId/vendors/$vendorId/locations/$locationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AccountActivationEmailRoute: typeof AccountActivationEmailRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/ops': {
      id: '/_authenticated/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof AuthenticatedOpsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contacts': {
      id: '/_authenticated/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthenticatedContactsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/': {
      id: '/_authenticated/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthenticatedEventsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/account/activation/$email': {
      id: '/account/activation/$email'
      path: '/account/activation/$email'
      fullPath: '/account/activation/$email'
      preLoaderRoute: typeof AccountActivationEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/ops/terminals': {
      id: '/_authenticated/ops/terminals'
      path: '/terminals'
      fullPath: '/ops/terminals'
      preLoaderRoute: typeof AuthenticatedOpsTerminalsRouteImport
      parentRoute: typeof AuthenticatedOpsRoute
    }
    '/_authenticated/ops/system': {
      id: '/_authenticated/ops/system'
      path: '/system'
      fullPath: '/ops/system'
      preLoaderRoute: typeof AuthenticatedOpsSystemRouteImport
      parentRoute: typeof AuthenticatedOpsRoute
    }
    '/_authenticated/ops/revenue': {
      id: '/_authenticated/ops/revenue'
      path: '/revenue'
      fullPath: '/ops/revenue'
      preLoaderRoute: typeof AuthenticatedOpsRevenueRouteImport
      parentRoute: typeof AuthenticatedOpsRoute
    }
    '/_authenticated/ops/pulse': {
      id: '/_authenticated/ops/pulse'
      path: '/pulse'
      fullPath: '/ops/pulse'
      preLoaderRoute: typeof AuthenticatedOpsPulseRouteImport
      parentRoute: typeof AuthenticatedOpsRoute
    }
    '/_authenticated/ops/fraud': {
      id: '/_authenticated/ops/fraud'
      path: '/fraud'
      fullPath: '/ops/fraud'
      preLoaderRoute: typeof AuthenticatedOpsFraudRouteImport
      parentRoute: typeof AuthenticatedOpsRoute
    }
    '/_authenticated/events/$eventId': {
      id: '/_authenticated/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AuthenticatedEventsEventIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contacts_/$userId': {
      id: '/_authenticated/contacts_/$userId'
      path: '/contacts/$userId'
      fullPath: '/contacts/$userId'
      preLoaderRoute: typeof AuthenticatedContactsUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/support-chat-analytics': {
      id: '/_authenticated/admin/support-chat-analytics'
      path: '/admin/support-chat-analytics'
      fullPath: '/admin/support-chat-analytics'
      preLoaderRoute: typeof AuthenticatedAdminSupportChatAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/account/activation/$email/$code': {
      id: '/account/activation/$email/$code'
      path: '/$code'
      fullPath: '/account/activation/$email/$code'
      preLoaderRoute: typeof AccountActivationEmailCodeRouteImport
      parentRoute: typeof AccountActivationEmailRoute
    }
    '/_authenticated/ops/events/new': {
      id: '/_authenticated/ops/events/new'
      path: '/events/new'
      fullPath: '/ops/events/new'
      preLoaderRoute: typeof AuthenticatedOpsEventsNewRouteImport
      parentRoute: typeof AuthenticatedOpsRoute
    }
    '/_authenticated/events/$eventId/vouchers': {
      id: '/_authenticated/events/$eventId/vouchers'
      path: '/vouchers'
      fullPath: '/events/$eventId/vouchers'
      preLoaderRoute: typeof AuthenticatedEventsEventIdVouchersRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/vendors': {
      id: '/_authenticated/events/$eventId/vendors'
      path: '/vendors'
      fullPath: '/events/$eventId/vendors'
      preLoaderRoute: typeof AuthenticatedEventsEventIdVendorsRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/users': {
      id: '/_authenticated/events/$eventId/users'
      path: '/users'
      fullPath: '/events/$eventId/users'
      preLoaderRoute: typeof AuthenticatedEventsEventIdUsersRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/transfer': {
      id: '/_authenticated/events/$eventId/transfer'
      path: '/transfer'
      fullPath: '/events/$eventId/transfer'
      preLoaderRoute: typeof AuthenticatedEventsEventIdTransferRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/transactions': {
      id: '/_authenticated/events/$eventId/transactions'
      path: '/transactions'
      fullPath: '/events/$eventId/transactions'
      preLoaderRoute: typeof AuthenticatedEventsEventIdTransactionsRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/toolkit': {
      id: '/_authenticated/events/$eventId/toolkit'
      path: '/toolkit'
      fullPath: '/events/$eventId/toolkit'
      preLoaderRoute: typeof AuthenticatedEventsEventIdToolkitRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/support': {
      id: '/_authenticated/events/$eventId/support'
      path: '/support'
      fullPath: '/events/$eventId/support'
      preLoaderRoute: typeof AuthenticatedEventsEventIdSupportRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/site-map': {
      id: '/_authenticated/events/$eventId/site-map'
      path: '/site-map'
      fullPath: '/events/$eventId/site-map'
      preLoaderRoute: typeof AuthenticatedEventsEventIdSiteMapRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/settings': {
      id: '/_authenticated/events/$eventId/settings'
      path: '/settings'
      fullPath: '/events/$eventId/settings'
      preLoaderRoute: typeof AuthenticatedEventsEventIdSettingsRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/reporting': {
      id: '/_authenticated/events/$eventId/reporting'
      path: '/reporting'
      fullPath: '/events/$eventId/reporting'
      preLoaderRoute: typeof AuthenticatedEventsEventIdReportingRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/reload': {
      id: '/_authenticated/events/$eventId/reload'
      path: '/reload'
      fullPath: '/events/$eventId/reload'
      preLoaderRoute: typeof AuthenticatedEventsEventIdReloadRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/promotions': {
      id: '/_authenticated/events/$eventId/promotions'
      path: '/promotions'
      fullPath: '/events/$eventId/promotions'
      preLoaderRoute: typeof AuthenticatedEventsEventIdPromotionsRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/orders': {
      id: '/_authenticated/events/$eventId/orders'
      path: '/orders'
      fullPath: '/events/$eventId/orders'
      preLoaderRoute: typeof AuthenticatedEventsEventIdOrdersRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/menu': {
      id: '/_authenticated/events/$eventId/menu'
      path: '/menu'
      fullPath: '/events/$eventId/menu'
      preLoaderRoute: typeof AuthenticatedEventsEventIdMenuRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/live-stats': {
      id: '/_authenticated/events/$eventId/live-stats'
      path: '/live-stats'
      fullPath: '/events/$eventId/live-stats'
      preLoaderRoute: typeof AuthenticatedEventsEventIdLiveStatsRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/integrations': {
      id: '/_authenticated/events/$eventId/integrations'
      path: '/integrations'
      fullPath: '/events/$eventId/integrations'
      preLoaderRoute: typeof AuthenticatedEventsEventIdIntegrationsRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/home-layout': {
      id: '/_authenticated/events/$eventId/home-layout'
      path: '/home-layout'
      fullPath: '/events/$eventId/home-layout'
      preLoaderRoute: typeof AuthenticatedEventsEventIdHomeLayoutRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/fraud': {
      id: '/_authenticated/events/$eventId/fraud'
      path: '/fraud'
      fullPath: '/events/$eventId/fraud'
      preLoaderRoute: typeof AuthenticatedEventsEventIdFraudRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/financials': {
      id: '/_authenticated/events/$eventId/financials'
      path: '/financials'
      fullPath: '/events/$eventId/financials'
      preLoaderRoute: typeof AuthenticatedEventsEventIdFinancialsRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/dashboard': {
      id: '/_authenticated/events/$eventId/dashboard'
      path: '/dashboard'
      fullPath: '/events/$eventId/dashboard'
      preLoaderRoute: typeof AuthenticatedEventsEventIdDashboardRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/card-phones': {
      id: '/_authenticated/events/$eventId/card-phones'
      path: '/card-phones'
      fullPath: '/events/$eventId/card-phones'
      preLoaderRoute: typeof AuthenticatedEventsEventIdCardPhonesRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/card-payments': {
      id: '/_authenticated/events/$eventId/card-payments'
      path: '/card-payments'
      fullPath: '/events/$eventId/card-payments'
      preLoaderRoute: typeof AuthenticatedEventsEventIdCardPaymentsRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/event-content/': {
      id: '/_authenticated/events/$eventId/event-content/'
      path: '/event-content'
      fullPath: '/events/$eventId/event-content/'
      preLoaderRoute: typeof AuthenticatedEventsEventIdEventContentIndexRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/vendors/$vendorId': {
      id: '/_authenticated/events/$eventId/vendors/$vendorId'
      path: '/$vendorId'
      fullPath: '/events/$eventId/vendors/$vendorId'
      preLoaderRoute: typeof AuthenticatedEventsEventIdVendorsVendorIdRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdVendorsRoute
    }
    '/_authenticated/events/$eventId/financials_/support-reloads': {
      id: '/_authenticated/events/$eventId/financials_/support-reloads'
      path: '/financials/support-reloads'
      fullPath: '/events/$eventId/financials/support-reloads'
      preLoaderRoute: typeof AuthenticatedEventsEventIdFinancialsSupportReloadsRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/event-content/create': {
      id: '/_authenticated/events/$eventId/event-content/create'
      path: '/event-content/create'
      fullPath: '/events/$eventId/event-content/create'
      preLoaderRoute: typeof AuthenticatedEventsEventIdEventContentCreateRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/fraud_/users/$userId': {
      id: '/_authenticated/events/$eventId/fraud_/users/$userId'
      path: '/fraud/users/$userId'
      fullPath: '/events/$eventId/fraud/users/$userId'
      preLoaderRoute: typeof AuthenticatedEventsEventIdFraudUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/event-content/$pageId/edit': {
      id: '/_authenticated/events/$eventId/event-content/$pageId/edit'
      path: '/event-content/$pageId/edit'
      fullPath: '/events/$eventId/event-content/$pageId/edit'
      preLoaderRoute: typeof AuthenticatedEventsEventIdEventContentPageIdEditRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/vendors/$vendorId/locations/$locationId': {
      id: '/_authenticated/events/$eventId/vendors/$vendorId/locations/$locationId'
      path: '/locations/$locationId'
      fullPath: '/events/$eventId/vendors/$vendorId/locations/$locationId'
      preLoaderRoute: typeof AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdVendorsVendorIdRoute
    }
  }
}

interface AuthenticatedOpsRouteChildren {
  AuthenticatedOpsFraudRoute: typeof AuthenticatedOpsFraudRoute
  AuthenticatedOpsPulseRoute: typeof AuthenticatedOpsPulseRoute
  AuthenticatedOpsRevenueRoute: typeof AuthenticatedOpsRevenueRoute
  AuthenticatedOpsSystemRoute: typeof AuthenticatedOpsSystemRoute
  AuthenticatedOpsTerminalsRoute: typeof AuthenticatedOpsTerminalsRoute
  AuthenticatedOpsEventsNewRoute: typeof AuthenticatedOpsEventsNewRoute
}

const AuthenticatedOpsRouteChildren: AuthenticatedOpsRouteChildren = {
  AuthenticatedOpsFraudRoute: AuthenticatedOpsFraudRoute,
  AuthenticatedOpsPulseRoute: AuthenticatedOpsPulseRoute,
  AuthenticatedOpsRevenueRoute: AuthenticatedOpsRevenueRoute,
  AuthenticatedOpsSystemRoute: AuthenticatedOpsSystemRoute,
  AuthenticatedOpsTerminalsRoute: AuthenticatedOpsTerminalsRoute,
  AuthenticatedOpsEventsNewRoute: AuthenticatedOpsEventsNewRoute,
}

const AuthenticatedOpsRouteWithChildren =
  AuthenticatedOpsRoute._addFileChildren(AuthenticatedOpsRouteChildren)

interface AuthenticatedEventsEventIdVendorsVendorIdRouteChildren {
  AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRoute: typeof AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRoute
}

const AuthenticatedEventsEventIdVendorsVendorIdRouteChildren: AuthenticatedEventsEventIdVendorsVendorIdRouteChildren =
  {
    AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRoute:
      AuthenticatedEventsEventIdVendorsVendorIdLocationsLocationIdRoute,
  }

const AuthenticatedEventsEventIdVendorsVendorIdRouteWithChildren =
  AuthenticatedEventsEventIdVendorsVendorIdRoute._addFileChildren(
    AuthenticatedEventsEventIdVendorsVendorIdRouteChildren,
  )

interface AuthenticatedEventsEventIdVendorsRouteChildren {
  AuthenticatedEventsEventIdVendorsVendorIdRoute: typeof AuthenticatedEventsEventIdVendorsVendorIdRouteWithChildren
}

const AuthenticatedEventsEventIdVendorsRouteChildren: AuthenticatedEventsEventIdVendorsRouteChildren =
  {
    AuthenticatedEventsEventIdVendorsVendorIdRoute:
      AuthenticatedEventsEventIdVendorsVendorIdRouteWithChildren,
  }

const AuthenticatedEventsEventIdVendorsRouteWithChildren =
  AuthenticatedEventsEventIdVendorsRoute._addFileChildren(
    AuthenticatedEventsEventIdVendorsRouteChildren,
  )

interface AuthenticatedEventsEventIdRouteChildren {
  AuthenticatedEventsEventIdCardPaymentsRoute: typeof AuthenticatedEventsEventIdCardPaymentsRoute
  AuthenticatedEventsEventIdCardPhonesRoute: typeof AuthenticatedEventsEventIdCardPhonesRoute
  AuthenticatedEventsEventIdDashboardRoute: typeof AuthenticatedEventsEventIdDashboardRoute
  AuthenticatedEventsEventIdFinancialsRoute: typeof AuthenticatedEventsEventIdFinancialsRoute
  AuthenticatedEventsEventIdFraudRoute: typeof AuthenticatedEventsEventIdFraudRoute
  AuthenticatedEventsEventIdHomeLayoutRoute: typeof AuthenticatedEventsEventIdHomeLayoutRoute
  AuthenticatedEventsEventIdIntegrationsRoute: typeof AuthenticatedEventsEventIdIntegrationsRoute
  AuthenticatedEventsEventIdLiveStatsRoute: typeof AuthenticatedEventsEventIdLiveStatsRoute
  AuthenticatedEventsEventIdMenuRoute: typeof AuthenticatedEventsEventIdMenuRoute
  AuthenticatedEventsEventIdOrdersRoute: typeof AuthenticatedEventsEventIdOrdersRoute
  AuthenticatedEventsEventIdPromotionsRoute: typeof AuthenticatedEventsEventIdPromotionsRoute
  AuthenticatedEventsEventIdReloadRoute: typeof AuthenticatedEventsEventIdReloadRoute
  AuthenticatedEventsEventIdReportingRoute: typeof AuthenticatedEventsEventIdReportingRoute
  AuthenticatedEventsEventIdSettingsRoute: typeof AuthenticatedEventsEventIdSettingsRoute
  AuthenticatedEventsEventIdSiteMapRoute: typeof AuthenticatedEventsEventIdSiteMapRoute
  AuthenticatedEventsEventIdSupportRoute: typeof AuthenticatedEventsEventIdSupportRoute
  AuthenticatedEventsEventIdToolkitRoute: typeof AuthenticatedEventsEventIdToolkitRoute
  AuthenticatedEventsEventIdTransactionsRoute: typeof AuthenticatedEventsEventIdTransactionsRoute
  AuthenticatedEventsEventIdTransferRoute: typeof AuthenticatedEventsEventIdTransferRoute
  AuthenticatedEventsEventIdUsersRoute: typeof AuthenticatedEventsEventIdUsersRoute
  AuthenticatedEventsEventIdVendorsRoute: typeof AuthenticatedEventsEventIdVendorsRouteWithChildren
  AuthenticatedEventsEventIdVouchersRoute: typeof AuthenticatedEventsEventIdVouchersRoute
  AuthenticatedEventsEventIdEventContentCreateRoute: typeof AuthenticatedEventsEventIdEventContentCreateRoute
  AuthenticatedEventsEventIdFinancialsSupportReloadsRoute: typeof AuthenticatedEventsEventIdFinancialsSupportReloadsRoute
  AuthenticatedEventsEventIdEventContentIndexRoute: typeof AuthenticatedEventsEventIdEventContentIndexRoute
  AuthenticatedEventsEventIdEventContentPageIdEditRoute: typeof AuthenticatedEventsEventIdEventContentPageIdEditRoute
  AuthenticatedEventsEventIdFraudUsersUserIdRoute: typeof AuthenticatedEventsEventIdFraudUsersUserIdRoute
}

const AuthenticatedEventsEventIdRouteChildren: AuthenticatedEventsEventIdRouteChildren =
  {
    AuthenticatedEventsEventIdCardPaymentsRoute:
      AuthenticatedEventsEventIdCardPaymentsRoute,
    AuthenticatedEventsEventIdCardPhonesRoute:
      AuthenticatedEventsEventIdCardPhonesRoute,
    AuthenticatedEventsEventIdDashboardRoute:
      AuthenticatedEventsEventIdDashboardRoute,
    AuthenticatedEventsEventIdFinancialsRoute:
      AuthenticatedEventsEventIdFinancialsRoute,
    AuthenticatedEventsEventIdFraudRoute: AuthenticatedEventsEventIdFraudRoute,
    AuthenticatedEventsEventIdHomeLayoutRoute:
      AuthenticatedEventsEventIdHomeLayoutRoute,
    AuthenticatedEventsEventIdIntegrationsRoute:
      AuthenticatedEventsEventIdIntegrationsRoute,
    AuthenticatedEventsEventIdLiveStatsRoute:
      AuthenticatedEventsEventIdLiveStatsRoute,
    AuthenticatedEventsEventIdMenuRoute: AuthenticatedEventsEventIdMenuRoute,
    AuthenticatedEventsEventIdOrdersRoute:
      AuthenticatedEventsEventIdOrdersRoute,
    AuthenticatedEventsEventIdPromotionsRoute:
      AuthenticatedEventsEventIdPromotionsRoute,
    AuthenticatedEventsEventIdReloadRoute:
      AuthenticatedEventsEventIdReloadRoute,
    AuthenticatedEventsEventIdReportingRoute:
      AuthenticatedEventsEventIdReportingRoute,
    AuthenticatedEventsEventIdSettingsRoute:
      AuthenticatedEventsEventIdSettingsRoute,
    AuthenticatedEventsEventIdSiteMapRoute:
      AuthenticatedEventsEventIdSiteMapRoute,
    AuthenticatedEventsEventIdSupportRoute:
      AuthenticatedEventsEventIdSupportRoute,
    AuthenticatedEventsEventIdToolkitRoute:
      AuthenticatedEventsEventIdToolkitRoute,
    AuthenticatedEventsEventIdTransactionsRoute:
      AuthenticatedEventsEventIdTransactionsRoute,
    AuthenticatedEventsEventIdTransferRoute:
      AuthenticatedEventsEventIdTransferRoute,
    AuthenticatedEventsEventIdUsersRoute: AuthenticatedEventsEventIdUsersRoute,
    AuthenticatedEventsEventIdVendorsRoute:
      AuthenticatedEventsEventIdVendorsRouteWithChildren,
    AuthenticatedEventsEventIdVouchersRoute:
      AuthenticatedEventsEventIdVouchersRoute,
    AuthenticatedEventsEventIdEventContentCreateRoute:
      AuthenticatedEventsEventIdEventContentCreateRoute,
    AuthenticatedEventsEventIdFinancialsSupportReloadsRoute:
      AuthenticatedEventsEventIdFinancialsSupportReloadsRoute,
    AuthenticatedEventsEventIdEventContentIndexRoute:
      AuthenticatedEventsEventIdEventContentIndexRoute,
    AuthenticatedEventsEventIdEventContentPageIdEditRoute:
      AuthenticatedEventsEventIdEventContentPageIdEditRoute,
    AuthenticatedEventsEventIdFraudUsersUserIdRoute:
      AuthenticatedEventsEventIdFraudUsersUserIdRoute,
  }

const AuthenticatedEventsEventIdRouteWithChildren =
  AuthenticatedEventsEventIdRoute._addFileChildren(
    AuthenticatedEventsEventIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedContactsRoute: typeof AuthenticatedContactsRoute
  AuthenticatedOpsRoute: typeof AuthenticatedOpsRouteWithChildren
  AuthenticatedAdminSupportChatAnalyticsRoute: typeof AuthenticatedAdminSupportChatAnalyticsRoute
  AuthenticatedContactsUserIdRoute: typeof AuthenticatedContactsUserIdRoute
  AuthenticatedEventsEventIdRoute: typeof AuthenticatedEventsEventIdRouteWithChildren
  AuthenticatedEventsIndexRoute: typeof AuthenticatedEventsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedContactsRoute: AuthenticatedContactsRoute,
  AuthenticatedOpsRoute: AuthenticatedOpsRouteWithChildren,
  AuthenticatedAdminSupportChatAnalyticsRoute:
    AuthenticatedAdminSupportChatAnalyticsRoute,
  AuthenticatedContactsUserIdRoute: AuthenticatedContactsUserIdRoute,
  AuthenticatedEventsEventIdRoute: AuthenticatedEventsEventIdRouteWithChildren,
  AuthenticatedEventsIndexRoute: AuthenticatedEventsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface AccountActivationEmailRouteChildren {
  AccountActivationEmailCodeRoute: typeof AccountActivationEmailCodeRoute
}

const AccountActivationEmailRouteChildren: AccountActivationEmailRouteChildren =
  {
    AccountActivationEmailCodeRoute: AccountActivationEmailCodeRoute,
  }

const AccountActivationEmailRouteWithChildren =
  AccountActivationEmailRoute._addFileChildren(
    AccountActivationEmailRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AccountActivationEmailRoute: AccountActivationEmailRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
